import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const Background = "https://storage.googleapis.com/think41-web-new/assets/Career/CareerPageBackground.svg"
const graduateIcon =  "https://storage.googleapis.com/think41-web-new/assets/Career/mdi_college-outline.svg";
const experiencedIcon =   "https://storage.googleapis.com/think41-web-new/assets/Career/experiencedIcon.svg";



const ctaTextStyle = {
  fontFamily: "Montserrat, sans-serif",
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "100%",
  fontStyle: "normal",
  fontFeatureSettings: "'liga' off, 'clig' off",
};

const CareerHero = ({ jobRef }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const selected =
    location.pathname === "/careers2" ? "experienced" : "graduate";

  const handleGraduateClick = () => {
    if (selected !== "graduate") {
      navigate("/careers#boot41");
    } else if (jobRef?.current) {
      jobRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleExperiencedClick = () => {
    if (selected !== "experienced") {
      navigate("/careers2#jobs");
    } else if (jobRef?.current) {
      jobRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div
      className="w-full min-h-[55vh] flex flex-col items-center justify-center bg-cover bg-center relative overflow-hidden px-4"
      style={{
        backgroundImage: `url(${Background})`,
      }}
    >
      {/* Header and Text */}
      <div className="max-w-[790px] w-full flex flex-col items-center gap-[36px] text-center">
        <h1 className="font-montserrat text-[32px] md:text-[50px] font-semibold leading-tight bg-gradient-to-r from-black to-[#0060C7] text-transparent bg-clip-text mt-30">
          Lead . Grow . Have Serious Fun
        </h1>
        <p className="mt-3 text-[#333] text-[16px] sm:text-[18px] md:text-[20px] font-normal font-montserrat">
          We solve real problems with AI, move fast as a team, and take joy
          seriously. At Think41, growth isn’t just professional—it’s personal,
          playful, and built on ownership.
        </p>
      </div>

      {/* CTA Buttons */}
      <div className="w-full max-w-[300px] md:max-w-[1000px] flex justify-center mt-[60px] md:mt-[120px] mb-[30px]">
        {/* Mobile View */}
        <div className="md:hidden flex w-full bg-[#F5F9FF] rounded-[8px] md:mb-0 mb-[20px]">
          <button
            onClick={handleGraduateClick}
            className={`flex-1 h-[44px] rounded-[10px] flex items-center justify-center text-sm font-medium gap-2 transition-all duration-300 ${
              selected === "graduate"
                ? "bg-[#0060C7] text-white"
                : "bg-[#F5F9FF] text-black"
            }`}
          >
            <img
              src={graduateIcon}
              alt="Graduate Students"
              className={`w-[18px] h-[18px] ${
                selected === "graduate" ? "" : "invert"
              }`}
            />
            <span style={ctaTextStyle}>Graduates</span>
          </button>
          <button
            onClick={handleExperiencedClick}
            className={`flex-1 h-[44px] rounded-[10px] flex items-center justify-center text-sm font-medium gap-2 transition-all duration-300 ${
              selected === "experienced"
                ? "bg-[#0060C7] text-white"
                : "bg-[#F5F9FF] text-black"
            }`}
          >
            <img
              src={experiencedIcon}
              alt="Experienced Professionals"
              className="w-[18px] h-[18px]"
              style={{
                filter:
                  selected === "experienced"
                    ? "invert(1) brightness(2)"
                    : "invert(0) brightness(0)",
                transition: "filter 0.3s",
              }}
            />
            <span style={ctaTextStyle}>Experienced</span>
          </button>
        </div>

        {/* Desktop View */}
        <div className="hidden md:flex max-w-max bg-[#E9EEFC] h-[42px] rounded-[8px] items-center justify-center">
          <button
            onClick={handleGraduateClick}
            className={`flex-1 cursor-pointer w-[600px] h-[42px] rounded-[8px] flex items-center justify-center text-sm font-medium gap-2 transition-all duration-300 ${
              selected === "graduate"
                ? "bg-[#0060C7] text-white"
                : "bg-[#E9EEFC] text-black"
            }`}
          >
            <img
              src={graduateIcon}
              alt="Graduate Students"
              className={`w-[24px] h-[24px] ${
                selected === "graduate" ? "" : "invert"
              }`}
            />
            <span style={ctaTextStyle}>Graduate Students</span>
          </button>
          <button
            onClick={handleExperiencedClick}
            className={`flex-1 cursor-pointer w-[00px] h-[42px] rounded-[8px] flex items-center justify-center text-sm font-medium gap-2 transition-all duration-300 ${
              selected === "experienced"
                ? "bg-[#0060C7] text-white"
                : "bg-[#E9EEFC] text-black"
            }`}
          >
            <img
              src={experiencedIcon}
              alt="Experienced Professionals"
              className="w-[22px] h-[22px]"
              style={{
                filter:
                  selected === "experienced"
                    ? "invert(1) brightness(2)"
                    : "invert(0) brightness(0)",
                transition: "filter 0.3s",
              }}
            />
            <span style={ctaTextStyle}>Experienced Professionals</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CareerHero;
